import {schema} from 'normalizr';

export const coverageZone = new schema.Entity(
  'coverage_zone',
  {},
  { idAttribute: 'id' }
);

export const coverageZones = {coverage_zone: new schema.Array(coverageZone)}; // eslint-disable-line camelcase
